import React, { useEffect, useCallback, useRef } from 'react';
import * as PropTypes from 'prop-types';
import { STEPS, FORMDATA_FIELDS } from '../config';
import { useTranslation } from 'react-i18next';
import { StyledSection } from '../styled';
import { ActivityAssosiationFields } from '../../completeActivity/components';

const { ENTITIES } = FORMDATA_FIELDS;

const EMPTY_ARRAY = [];

const ScheduleActivityObjects = ({
  isEmpty,
  assignments,
  getKeyListenersProps,
  dispatchAssignment,
  activityRelatedObjects,
  updateValidation,
  updateField,
  associatedEntities,
  isLastIndex,
  isAssociationRequired,
  loading,
}) => {
  const { t } = useTranslation();
  const isValid =
    !isAssociationRequired || Boolean(associatedEntities.length) || isEmpty;

  const initRef = useRef(true);

  useEffect(() => {
    updateValidation(STEPS.RELATED_OBJECTS, isValid);
  }, [isValid, updateValidation]);

  const handleOnChange = useCallback(
    (setterProp) => (value) => {
      initRef.current = false;
      dispatchAssignment({
        ...setterProp,
        value,
      });
    },
    [dispatchAssignment]
  );

  useEffect(() => {
    if (isEmpty) {
      updateField(ENTITIES, [], initRef.current);
    }
  });

  useEffect(() => {
    activityRelatedObjects.length &&
      updateField(
        ENTITIES,
        activityRelatedObjects
          .filter((v) => v.name !== '')
          .map((obj) => ({
            customObjectId: obj.id,
            entityId:
              assignments[obj.component.getterProp] &&
              (assignments[obj.component.getterProp].id ||
                assignments[obj.component.getterProp].value),
          }))
          .filter((v) => v.entityId),
        initRef.current
      );
  }, [assignments, activityRelatedObjects, updateField]);

  if (isEmpty) return null;

  return (
    <StyledSection
      index={1}
      header={t('Set Associations')}
      isLastIndex={isLastIndex}
      isActive
    >
      <ActivityAssosiationFields
        activityRelatedObjects={activityRelatedObjects}
        errors={EMPTY_ARRAY}
        loading={loading}
        handleChange={handleOnChange}
        getKeyListenersProps={getKeyListenersProps}
        assignments={assignments}
      />
    </StyledSection>
  );
};

ScheduleActivityObjects.propTypes = {
  updateField: PropTypes.func.isRequired,
  updateValidation: PropTypes.func.isRequired,
  activityRelatedObjects: PropTypes.array.isRequired,
  assignments: PropTypes.object.isRequired,
  dispatchAssignment: PropTypes.func.isRequired,
  associatedEntities: PropTypes.array.isRequired,
  isLastIndex: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default ScheduleActivityObjects;
